import { useEffect } from 'react';

const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'textarea:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

function getFocusable(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter((el) => {
    if (el.hasAttribute('aria-hidden')) return false;
    if (el.offsetParent === null && el !== document.activeElement) return false;
    return true;
  });
}

export function useFocusTrap(ref, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const node = ref && ref.current;
    if (!node) return undefined;

    const previous = document.activeElement;

    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      const list = getFocusable(node);
      if (list.length === 0) {
        e.preventDefault();
        if (typeof node.focus === 'function') node.focus();
        return;
      }
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    node.addEventListener('keydown', onKey);
    const initial = getFocusable(node)[0] || node;
    if (typeof initial.focus === 'function') initial.focus();

    return () => {
      node.removeEventListener('keydown', onKey);
      if (previous && typeof previous.focus === 'function') {
        try { previous.focus(); } catch (e) {  }
      }
    };
  }, [ref, active]);
}
